import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderFreightCreateAtom = createMutationAtomFactory(
  'trade.salesOrderFreightCreate',
  (params: {
    salesOrderId: string;
    carrierId?: string | null;
    freightLaneId?: string | null;
    rateFormula?: string | null;
    rateVariableIds?: string | null;
    chargebackFormula?: string | null;
    chargebackVariableIds?: string | null;
    fuelSurchargeFormula?: string | null;
    fuelSurchargeVariableIds?: string | null;
    fuelSurchargeMode?: string | null;
    notes?: string | null;
  }) => ({
    tradeSalesOrderFreightCreate: {
      __args: {
        input: {
          salesOrderId: params.salesOrderId,
          carrierId: params.carrierId,
          freightLaneId: params.freightLaneId,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          notes: params.notes,
        },
      },
      id: true,
      salesOrderId: true,
      carrierId: true,
      freightLaneId: true,
      rateFormula: true,
      chargebackFormula: true,
      fuelSurchargeFormula: true,
      fuelSurchargeMode: true,
      notes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const salesOrderFreightUpdateAtom = createMutationAtomFactory(
  'trade.salesOrderFreightUpdate',
  (params: {
    id: string;
    carrierId?: string | null;
    freightLaneId?: string | null;
    rateFormula?: string | null;
    rateVariableIds?: string | null;
    chargebackFormula?: string | null;
    chargebackVariableIds?: string | null;
    fuelSurchargeFormula?: string | null;
    fuelSurchargeVariableIds?: string | null;
    fuelSurchargeMode?: string | null;
    notes?: string | null;
  }) => ({
    tradeSalesOrderFreightUpdate: {
      __args: {
        id: params.id,
        input: {
          carrierId: params.carrierId,
          freightLaneId: params.freightLaneId,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          notes: params.notes,
        },
      },
      id: true,
      salesOrderId: true,
      carrierId: true,
      freightLaneId: true,
      rateFormula: true,
      chargebackFormula: true,
      fuelSurchargeFormula: true,
      fuelSurchargeMode: true,
      notes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const salesOrderFreightDeleteAtom = createMutationAtomFactory(
  'trade.salesOrderFreightDelete',
  (params: { id: string }) => ({
    tradeSalesOrderFreightDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
